/* eslint-disable n/no-unsupported-features/node-builtins -- this is a browser environment */

declare global {
  interface Window {
    IS_DHL_WEBVIEW: boolean
  }
}

export const isNative = (): boolean => {
  const isNativeUserAgent = !!navigator.userAgent.match('DHL_WEBVIEW.*com\\.dhlparcel\\.[a-z]+')
  return window?.IS_DHL_WEBVIEW === true || isNativeUserAgent
}
